module.exports = __webpack_public_path__ + "img/yiling.6742cb5c.png";